<template>
  <div>
    <ed-email :intContaEmailId="0" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdEmail from "@/components/configuracoes/contaBancaria/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdEmail },
  mounted() {},
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>